import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import React from 'react';
import './Disclosures.scss';
import { DisclosuresProps } from './Disclosures.types';
import DisclosuresText from 'src/components/DisclosuresText';
import { ROUTES } from 'src/constants/routes';

export const Disclosures: React.FC<DisclosuresProps> = ({
  state,
  paymentType,
  annualAmountPremium,
  monthlyDownPaymentAmount,
  monthlyInstallment,
  email,
  onChange,
}: DisclosuresProps) => {
  return (
    <div className="disclosures-container">
      <Typography variant="h4">Disclosures</Typography>
      <div className="disclosures-content">
        <DisclosuresText state={state}
         paymentType={paymentType}
         annualAmountPremium={annualAmountPremium}
         monthlyDownPaymentAmount={monthlyDownPaymentAmount}
         monthlyInstallment={monthlyInstallment}
         email={email}
        />
      </div>
      <div className="disclosures-instructions">
        <Typography variant="body1">
          A detailed listing of all policy coverages, government levied taxes,
          and assessments will be provided with your policy. Your insurance
          policy may include optional endorsements.
        </Typography>
      </div>
      <div className="disclosures-instructions">
        <Typography variant="body1">
          I have read, understand and agree to the Automatic Payment{' '}
          <a target="_blank" href={ROUTES.SERVICE_TERMS_PATH} style={{ color: 'inherit' }}>
            Terms and Conditions
          </a>
          , and intend this checkbox to serve as my electronic signature
          accepting such terms and conditions.
        </Typography>
      </div>
      <div className="disclosures-instructions">
        <FormControlLabel
          label={
            <Typography variant="caption">
              I acknowledge that I have read the agreement.
            </Typography>
          }
          control={
            <Checkbox name="accept-disclosure" onChange={(e) => onChange(e.target.checked as boolean)}/>
          }
        />
      </div>
    </div>
  );
};
